import { ExpandableText, Grid } from 'portal-commons';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { TableCell, TableRow } from '@material-ui/core';

import { CroppableItem } from '@/components';
import { createCampaignRedirectorPath } from '@/utils/path';
import { humanizeAuthenticatedUser } from '@/utils/string';
import { convertTimeWithTimezone } from '@/utils/time';

const EventsListingRow = (props) => {
  const { event } = props;
  const createDate = convertTimeWithTimezone(event.createDate);
  const authenticatedUser = humanizeAuthenticatedUser(event.authenticatedUser);

  return (
    <TableRow data-testid="EventListingRow">
      <TableCell
        align="left"
        style={{ fontWeight: 500 }}
        data-testid="EventListingRowEventType"
      >
        {event.eventType ? event.eventType : '--'}
      </TableCell>
      <TableCell align="left" data-testid="EventListingRowCategoryType">
        {event.categoryType}
      </TableCell>
      <TableCell
        align="left"
        className={`${event.campaignUid ? 'events-listing-table-link' : ''}`}
        data-testid="EventListingRowCampaignId"
        onClick={() => {
          if (event.campaignUid) {
            props.history.push({
              pathname: createCampaignRedirectorPath(event.campaignUid),
              state: {
                goBackPage: `${props.location.pathname}${
                  props.location.search ? props.location.search : ''
                }`,
              },
            });
          }
        }}
      >
        {event.campaignUid}
      </TableCell>
      <TableCell align="left" data-testid="EventListingRowBrandId">
        {event.brandUid}
      </TableCell>
      <TableCell
        align="left"
        style={{ maxWidth: 160 }}
        data-testid="EventListingRowCreateDate"
      >
        <CroppableItem title={createDate}>{createDate}</CroppableItem>
      </TableCell>
      <TableCell
        style={{ maxWidth: 120 }}
        align="left"
        data-testid="EventListingRowAuthenticatedUser"
      >
        <CroppableItem title={authenticatedUser}>
          {authenticatedUser}
        </CroppableItem>
      </TableCell>
      <TableCell align="left" data-testid="EventListingRowDescription">
        <Grid
          sx={{
            gridTemplateColumns: 'minmax(200px, 1fr)',
            width: '100%',
          }}
        >
          <ExpandableText text={event.description} maxWidth="100%" />
        </Grid>
      </TableCell>
    </TableRow>
  );
};

export default withRouter(EventsListingRow);
